<template>
  <div class="catalog-blog-card">
    <a :href="result.detailPage">
      <DefImg :result="result.picture" />
    </a>

    <div class="catalog-blog-card__block">
      <div class="catalog-blog-card__labels">
        <span
          v-for="item in result.labels"
          class="catalog-blog-card__label"
          :style="`background-color: ${item.color}`"
        >
          {{ item.name }}
        </span>
      </div>
      <a :href="result.detailPage" class="catalog-blog-card__title">{{ result.name }}</a>
    </div>
  </div>
  <Banner v-if="result.key === 2" :result="banner" />
</template>

<script lang="ts" setup>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import Banner from '@components/Banners/Banner.vue';
import { useCatalogStore } from '@/storePinia/stores/catalog';
import { computed } from 'vue';

const props = defineProps(['result']);

const catalogStore = useCatalogStore();

const banner = computed(() => catalogStore.catalogSectionList?.banners?.blog);
</script>

<style lang="scss" scoped>
.catalog-blog-card {
  position: relative;
  &__block {
    padding: 16px;
    position: absolute;
    bottom: 0;
    @include point-md {
      padding: 20px;
    }
    @include point-lg {
      padding: 40px;
    }
  }
  &__title {
    font-weight: 500;
    font-size: rem(16);
    line-height: 125%;
    color: #ffffff;
    margin-bottom: 0;
    @include point-md {
      font-size: rem(20);
    }
    @include point-lg {
      font-size: rem(24);
    }
  }
  &__labels {
    margin-bottom: 12px;
    @include point-md {
      margin-bottom: 16px;
    }
  }
  &__label {
    font-weight: 600;
    font-size: rem(10);
    text-transform: uppercase;
    padding: 4px 6px;
    border-radius: 2px;
    @include point-md {
      font-size: rem(12);
    }
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
